<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Registro de Atividades" :on-back="() => router.go(-1)" />
    <v-row justify="center" align="center">
      <v-col>
        <data-table
          :headers="headers"
          :filters="filters"
          :provider="fetch"
        >
          <template #[`item.batch_uuid`]="{ item }">
            <span> {{ item.batch_uuid?.split('-')[0] }}</span>
          </template>
          <template #[`item.causer`]="{ item }">
            <div class="d-flex flex-column">
              <div>{{ item.causer?.name }}</div>
              <div class="text-caption">
                {{ item.causer?.email }}
              </div>
            </div>
          </template>
          <template #[`item.event`]="{ item }">
            <span>
              {{ ActivityEventLabels[item.event as ActivityEvent] }}
            </span>
          </template>
          <template #[`item.created_at`]="{ item }">
            <span>
              {{ DateTime.fromISO(item.created_at).toFormat("dd/MM/yyyy HH:mm:ss") }}
            </span>
          </template>
        </data-table>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import DataTable from '@/components/datatable/DataTable.vue'
import TPageTitle from '@/components/TPageTitle.vue'
import { useSnackBar } from '@/stores/snackbar'
import ActivityService from '@/services/ActivityService'
import { ref } from 'vue'
import { DateTime } from 'luxon'
import { ActivityEventLabels } from '@/constants/Activity'
import { ActivityEvent } from '@/types/Activity'
import { DataTableFilter } from '@/types/DataTable'
import { useSelectFilter } from '@/helpers/reports/selectFilter'
import { useDateIntervalFilter } from '@/helpers/reports/dateIntervalFilter'
import { useProducerFilter } from '@/helpers/reports/producerFilter'

const router = useRouter()
const snackbar = useSnackBar()

const headers = ref([
  { key: 'id', value: 'id', title: 'ID', sortable: false },
  { key: 'producer', value: 'producer.data.display_name', title: 'Produtor', sortable: false },
  { key: 'causer', value: 'causer.name', title: 'Usuário', sortable: false },
  { key: 'description', value: 'description', title: 'Descrição', sortable: false },
  { key: 'event', value: 'event', title: 'Ação', sortable: false },
  { key: 'created_at', value: 'created_at', title: 'Data', sortable: false },
])

const eventTypeItems = Object.entries(ActivityEventLabels).reduce((prev, [key, val]) => {
  return [...prev, { title: val, value: key } ]
}, [] as { title: string, value: string }[])

const filters = ref<DataTableFilter[]>([
  useProducerFilter({
    label: 'Produtor',
    field: 'producer_id',
    icon: 'fas fa-shield',
  }),
  useSelectFilter({
    field: 'event',
    label: 'Tipo de ação',
    icon: 'fa-solid fa-list',
    items: [ { title: 'Todos', value: '' }, ...eventTypeItems],
    required: false,
    initial: '',
  }),
  useDateIntervalFilter({
    field: 'created_at',
    label: 'Data',
    icon: 'fa-solid fa-clock',
    required: false,
    initial: [
      DateTime.now().minus({ days: 30 }).toJSDate(),
      DateTime.now().toJSDate(),
    ],
  }),
])

async function fetch(page: number, filters: string, per_page?: number) {
  try {
    return await new ActivityService().index(page, filters, per_page)
  } catch (error) {
    snackbar.show('Não foi possível buscar o registro de atividades.', 'error')
    throw error
  }
}

</script>
